/**
 * StatusBadge — Color-coded status indicator.
 */

import type { DocumentStatus } from '../api/types';

interface StatusBadgeProps {
  status: DocumentStatus | string;
}

const statusConfig: Record<string, { bg: string; text: string; label: string }> = {
  uploaded: { bg: 'bg-blue-100', text: 'text-blue-800', label: 'Uploaded' },
  sanitizing: { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'Sanitizing' },
  sanitized: { bg: 'bg-green-100', text: 'text-green-800', label: 'Sanitized' },
  extracting: { bg: 'bg-purple-100', text: 'text-purple-800', label: 'Extracting' },
  extracted: { bg: 'bg-purple-100', text: 'text-purple-800', label: 'Extracted' },
  mapping: { bg: 'bg-indigo-100', text: 'text-indigo-800', label: 'Mapping' },
  mapped: { bg: 'bg-indigo-100', text: 'text-indigo-800', label: 'Mapped' },
  scoring: { bg: 'bg-orange-100', text: 'text-orange-800', label: 'Scoring' },
  scored: { bg: 'bg-orange-100', text: 'text-orange-800', label: 'Scored' },
  indexing: { bg: 'bg-cyan-100', text: 'text-cyan-800', label: 'Indexing' },
  indexed: { bg: 'bg-cyan-100', text: 'text-cyan-800', label: 'Indexed' },
  completed: { bg: 'bg-green-100', text: 'text-green-800', label: 'Completed' },
  failed: { bg: 'bg-red-100', text: 'text-red-800', label: 'Failed' },
  failed_privacy_scan: { bg: 'bg-red-100', text: 'text-red-800', label: 'Privacy Failed' },
  privacy_review_required: { bg: 'bg-amber-100', text: 'text-amber-800', label: 'Review Required' },
  indexing_skipped: { bg: 'bg-gray-100', text: 'text-gray-800', label: 'Skipped' },
  indexing_failed: { bg: 'bg-red-100', text: 'text-red-800', label: 'Index Failed' },
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status] || {
    bg: 'bg-gray-100',
    text: 'text-gray-800',
    label: status,
  };

  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-full text-[15px] font-semibold ${config.bg} ${config.text}`}
    >
      {config.label}
    </span>
  );
}
